import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames/bind";
import styles from "./text.module.scss";

const cx = classNames.bind(styles);

const color = ["inherit", "green", "black", "grey", "white", "blue"];

const Text = ({ children, style = "b2", color, className, ...props }) => {
  return (
    <p className={cx("text", style, color, className)} {...props}>
      {children}
    </p>
  );
};

Text.PropTypes = {
  color: PropTypes.oneOf(color)
};

export { Text as default };
